import useFetchLead from 'components/domain/lead/useFetchLead';
import useAppUser from 'hooks/useAppUser';

const leadGqlFields = `
  checkInDateTimeString,
  email,
  firstName,
  lastName,
  uid,
`;

const useFetchLeadForLeadCell = ({
  leadUid,
  enabled = true,
}: {
  leadUid: string;
  enabled?: boolean;
}) => {
  const { agencyUid } = useAppUser();

  return useFetchLead({
    enabled: enabled && !!agencyUid,
    fields: leadGqlFields,
    leadUid,
  });
};

export default useFetchLeadForLeadCell;
